var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-layout',{staticClass:"not-found-page"},[_c('div',{staticClass:"centered"},[_c('h1',[_c('img',{attrs:{"src":"static/img/404.png","height":"323","width":"594"}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('estaPaginaNoSeEncuentraEnElSistema')))]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"#/"}},[_vm._v(_vm._s(_vm.$t('volverAlInicio')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50fd7c7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/GeneralViews/NotFoundPage.vue
// module id = i4Dx
// module chunks = 4